import { Book } from './Book'
import { Menu } from './Menu'
import { Politics } from './Politics'
import { ModalAppLoad } from './MobAppLoad'


export const Modal = { Menu, Book, Politics, ModalAppLoad }
